import { styled } from '@mui/material/styles';

export const LoaddingContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 230px;
`;
